import { UrlUtil } from "@mcleod/core";
import { AutogenLayoutCommissionsHistoryList } from "./autogen/AutogenLayoutCommissionsHistoryList";

export class CommissionsHistoryList extends AutogenLayoutCommissionsHistoryList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "ending_pay_date", sort: "desc" }];
        const urlProps = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProps?.postKey) {
            this.mainDataSource.search({ post_key: urlProps.postKey });
        }
    }
}
